import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shadow-puppetry',
  templateUrl: './shadow-puppetry.component.html',
  styleUrls: ['./shadow-puppetry.component.scss']
})
export class ShadowPuppetryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
